import { IconProps } from "./Icon.model";

export function SnippetIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "var(--slate-11)" : `var(--${fill}-8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 6.25C6.25 5.97386 6.47386 5.75 6.75 5.75H10.25C10.5261 5.75 10.75 5.97386 10.75 6.25C10.75 6.52614 10.5261 6.75 10.25 6.75H6.75C6.47386 6.75 6.25 6.52614 6.25 6.25ZM6.25 7.75C6.25 7.47386 6.47386 7.25 6.75 7.25H10.25C10.5261 7.25 10.75 7.47386 10.75 7.75C10.75 8.02614 10.5261 8.25 10.25 8.25H6.75C6.47386 8.25 6.25 8.02614 6.25 7.75ZM6.25 9.25C6.25 8.97386 6.47386 8.75 6.75 8.75H8C8.27614 8.75 8.5 8.97386 8.5 9.25C8.5 9.52614 8.27614 9.75 8 9.75H6.75C6.47386 9.75 6.25 9.52614 6.25 9.25Z"
        fill={fillColor}
      />
      <path
        d="M4.1063 0.11942C3.78687 -0.000365987 3.43102 -0.00020842 2.91632 1.9478e-05C2.47695 1.51269e-05 2.03602 3.18158e-05 1.74985 0.0252581C1.45498 0.0512507 1.19694 0.106231 0.96129 0.237738C0.657667 0.407177 0.407138 0.657706 0.237698 0.961329C0.106191 1.19698 0.0512113 1.45502 0.0252188 1.74989C-7.35372e-06 2.03606 -4.02292e-06 2.39042 1.05219e-07 2.82979V4.40373C-6.10906e-06 5.55792 -1.10641e-05 6.46244 0.0948735 7.16819C0.191993 7.89055 0.394664 8.46057 0.842068 8.90797C1.28947 9.35538 1.85949 9.55805 2.58185 9.65517C3.2876 9.75005 4.19212 9.75005 5.34631 9.75004H5.625V6.25C5.625 5.62868 6.12868 5.125 6.75 5.125H10.75C10.75 5.09069 10.75 5.05609 10.75 5.02117C10.75 4.51166 10.75 4.05944 10.7165 3.72978C10.6819 3.3895 10.6084 3.0944 10.434 2.83335C10.2972 2.62861 10.1214 2.45283 9.91669 2.31603C9.65564 2.1416 9.36054 2.06818 9.02026 2.03356C8.6906 2.00003 8.27973 2.00003 7.77024 2.00004L5.99303 2.00004C5.83498 2.00004 5.74478 1.99958 5.67821 1.99269C5.62719 1.98912 5.5924 1.95131 5.58138 1.93285C5.54545 1.87639 5.41691 1.61958 5.34623 1.47822C5.11022 1.00065 4.80403 0.381065 4.1063 0.11942Z"
        fill={fillColor}
      />
    </svg>
  );
}

